import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UiCardInfoModule } from '@components/shared/ui-card-info/ui-card-info.module';
import { DirectivesModule } from '@directives/directives.module';
import { TranslateModule } from '@ngx-translate/core';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { UiFoldersDefaultRolesComponent } from './ui-folders-default-roles.component';

@NgModule({
    imports: [
        CommonModule,
        MatTooltipModule,
        MatButtonModule,
        UiNgLetModule,
        MatListModule,
        UiContentLoaderModule,
        UiSpinnerButtonModule,
        TranslateModule,
        MatIconModule,
        UiCardInfoModule,
        DirectivesModule,
    ],
    declarations: [
        UiFoldersDefaultRolesComponent,
    ],
    exports: [UiFoldersDefaultRolesComponent],
})
export class UiFoldersDefaultRolesModule { }
